import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import DeeplinkIcon from "../../component/modal/img/deeplinkIcon.svg";
import ChevronIcon from "../../component/dropdown/img/downArrow.svg";
import { useAuth } from "../../config/utilities/useAuth";
import { useInstitutionDeeplinks } from "../../config/utilities/useInstitutionDeeplinks";
import { openDeeplink } from "../../config/utilities/deeplinkHelpers";
import {
  dashboardPath,
  DASHBOARD_PATHS,
  isDashboardRoute,
} from "../../config/dashboardRoutes.js";

const getDeeplinkId = (deeplink) =>
  deeplink?.deeplinkId || deeplink?._id || deeplink?.url || "";

const SidebarExternalApps = ({ onNavigate = () => {} }) => {
  const { privilege } = useAuth();
  const { deeplinks = [] } = useInstitutionDeeplinks(privilege?.institutionId);
  const location = useLocation();
  const isOnExternalAppsPage = isDashboardRoute(
    location.pathname,
    DASHBOARD_PATHS.externalApps
  );
  const [isExpanded, setIsExpanded] = useState(isOnExternalAppsPage);

  useEffect(() => {
    if (isOnExternalAppsPage) {
      setIsExpanded(true);
    }
  }, [isOnExternalAppsPage]);

  if (deeplinks.length === 0) return null;

  const openDeeplinkAndNavigate = (url) => {
    openDeeplink(url);
    onNavigate();
  };

  return (
    <li className="sidebar-nav-item sidebar-external-apps">
      <div
        className={`sidebar-external-apps-row${
          isOnExternalAppsPage ? " is-active" : ""
        }`}
      >
        <NavLink
          to={dashboardPath(DASHBOARD_PATHS.externalApps)}
          onClick={onNavigate}
          className="sidebar-external-apps-link"
        >
          <img
            src={DeeplinkIcon}
            alt=""
            className="sidebar-nav-icon"
            aria-hidden="true"
          />
          <span>External Apps</span>
        </NavLink>
        <button
          type="button"
          className={`sidebar-external-apps-chevron${
            isExpanded ? " is-expanded" : ""
          }`}
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
          aria-label={
            isExpanded ? "Collapse external apps" : "Expand external apps"
          }
        >
          <img src={ChevronIcon} alt="" aria-hidden="true" />
        </button>
      </div>

      {isExpanded && (
        <ul className="sidebar-external-apps-sublist">
          {deeplinks.map((deeplink) => (
            <li key={getDeeplinkId(deeplink)}>
              <button
                type="button"
                className="sidebar-external-apps-sublink"
                onClick={() => openDeeplinkAndNavigate(deeplink.url)}
              >
                {deeplink.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarExternalApps;
